<template>
  <TableGradient
      icon-name="trash"
      :title="$t('reportTrash.listagem.titulo_pagina')"
      :text-empty="$t('reportTrash.listagem.table.empty')"
      :fields="fields"
      :fields-filter="filter"
      :items="reportTrashs"
      :paginator="paginator"
      :loading="isLoading"
      @list="evt => $store.dispatch('reportTrash/listAll', evt)"
      table-data>
    <template v-slot:cell(id)="linha">
      <router-link :id="`link-edit-${linha.index}`" :to="{ name: 'vns.report_trash.edit', params: { id: linha.item.id }}"
                   class="font-weight-bold">
        {{ $t('reportTrash.listagem.table.editar') }}
      </router-link>
    </template>    
  </TableGradient>
</template>

<script>
import TableGradient from "@/templates/TableGradient";
import {mapActions, mapGetters} from 'vuex'

export default {
  name: "Index",
  components: {TableGradient},
  computed: {
    ...mapGetters({
      reportTrashs: 'reportTrash/all',
      paginator: 'reportTrash/pagination',
      reportTrashIsLoading: 'reportTrash/isLoading'
    }),
    isLoading() {
      return !(this.mounted && this.reportTrashIsLoading === false)
    }
  },
  data() {
    return {
      mounted: false,
      fields: [
        {key: 'vns', label: this.$t('reportTrash.listagem.table.nome'), sortable: true, keyFullName: 'vns.name'},
        {key: 'company_name', label: this.$t('reportTrash.listagem.table.empresa'), sortable: true},
        {key: 'report_trash', label: this.$t('reportTrash.listagem.table.resultado_descartavel')},
        {key: 'id', label: this.$t('reportTrash.listagem.table.editar')}
      ],
      filter: [
        {key: 'vns', label: this.$t('reportTrash.listagem.table.nome')},
        {key: 'company_name', label: this.$t('reportTrash.listagem.table.empresa')},
      ]
    }
  },
  methods: {
    ...mapActions([
      'reportTrash/listAll'
    ])
  },
  mounted() {
    this['reportTrash/listAll'](this.paginator)
    this.mounted = true
  }
}
</script>

<style lang="scss" scoped>
</style>
